module.exports = __webpack_public_path__ + "static/img/生日.8751107.png";


//////////////////
// WEBPACK FOOTER
// ./static/user/center/生日.png
// module id = 47
// module chunks = 18